import { PageHero, Reveal, SectionHead, MaskedLine, PhotoFrame } from "@/components/Shared";
import { IMG, usePageContent } from "@/lib/api";
import { PAGES } from "@/content/pageContent";

export default function NorthStar() {
  const c = usePageContent("north-star", PAGES["north-star"].defaults);
  return (
    <main>
      <PageHero eyebrow="Our North Star · Rotary Year 2026–27" title="The vision that" italic="guides us" image={IMG.celestialSky}>
        <p className="text-sm leading-relaxed text-silver-dim sm:text-base">
          {c.heroText}
        </p>
      </PageHero>

      {/* The Theme */}
      <section className="relative overflow-hidden py-28" data-testid="north-star-theme">
        <div className="absolute inset-0">
          <img src={IMG.leopardForest} alt="" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
          <MaskedLine>
            <p className="eyebrow">The Year Theme</p>
          </MaskedLine>
          <MaskedLine delay={0.12}>
            <h2 className="mt-6 font-grotesk text-5xl font-semibold tracking-tight text-white sm:text-7xl">{c.themeTitle}</h2>
          </MaskedLine>
          <MaskedLine delay={0.24}>
            <p className="mt-2 font-display text-3xl italic text-silver sm:text-5xl">{c.themeSubtitle}</p>
          </MaskedLine>
          <Reveal delay={0.28}>
            <PhotoFrame src={c.yearBanner || null} label="Year banner coming soon" className="mx-auto mt-12 aspect-[21/9] w-full max-w-3xl" />
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mx-auto mt-10 max-w-3xl space-y-6 text-base leading-relaxed text-silver-dim sm:text-lg" data-testid="north-star-manifesto">
              {c.manifesto.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              {c.manifestoClosing && (
                <p className="pt-3 font-display text-lg italic text-silver sm:text-xl">{c.manifestoClosing}</p>
              )}
            </div>
          </Reveal>
        </div>
      </section>

      {/* The Vision */}
      <section className="mx-auto max-w-5xl px-6 py-24 text-center" data-testid="north-star-vision">
        <Reveal>
          <p className="eyebrow">The Vision</p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 font-display text-4xl font-medium italic leading-snug sm:text-6xl">
            <span className="metallic">{c.visionQuoteA}</span> <span className="text-silver">{c.visionQuoteB}</span>
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-silver-muted sm:text-base">
            {c.visionText}
          </p>
        </Reveal>
      </section>

      {/* The Goals */}
      <section className="mx-auto max-w-7xl px-6 pb-28" data-testid="north-star-goals">
        <SectionHead eyebrow="11th Year, 11 Goals" title="What we are" italic="working toward" grotesk align="center" />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {c.goals.map((goal, i) => (
            <Reveal key={i} delay={i * 0.05} className="h-full">
              <div className="card-line corner-frame flex h-full items-start gap-5 p-7" data-testid={`north-star-goal-${i}`}>
                <span className="font-grotesk text-2xl font-semibold tracking-tight text-ember">{String(i + 1).padStart(2, "0")}</span>
                <p className="text-sm leading-relaxed text-silver-muted">{goal}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
